
import { mapState, mapActions, mapGetters } from "vuex";

import InvoicesDetailed from "../invoices/invoices-detailed.vue";
import VueHtml2pdf from "vue-html2pdf";
import ResponsiveDialog from "../../components/dialogs/responsive-dialog.vue";

export default {
  components: {
    InvoicesDetailed,
    VueHtml2pdf,
    ResponsiveDialog
  },
  props: {
    dialog: {
      default: false
    },
    invoiceId: {
      default: null
    }
  },
  data() {
    return {
      enableDownload: false,
      modalPreview: false,
      loading: false,
      invoiceData: {},
      downloadLoading: false
    };
  },
  computed: {
    ...mapState("restaurant", ["businessDetails", "locationDetails"])
  },
  mounted() {
    this.loading = true;
    this.getInvoiceDetail({
      id: this.invoiceId,
      params: { location_id: this.locationDetails.id }
    })
      .then((data) => {
        this.invoiceData = data?.data;
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    ...mapActions("payment", ["getInvoiceDetail"]),
    getFileName() {
      return `Invoice_${this.businessDetails.name}`;
    },
    invoicePrint() {
      this.enableDownload = false;
      this.modalPreview = true;
      this.handleHtml2Pdf();
    },
    invoiceDownload() {
      this.downloadLoading = true;
      this.enableDownload = true;
      this.modalPreview = false;
      this.handleHtml2Pdf();
    },
    async handleHtml2Pdf() {
      await this.sleep(1000);
      this.$refs["html2Pdf__invoice"].generatePdf();
    },
    hasDownloaded() {
      this.downloadLoading = false;
      this.$emit("close-dialog");
    }
  }
};
